import React from 'react';
import PropTypes from 'prop-types';
import InputRange from 'react-input-range';

import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';
import { formatNumber } from 'utils/number';

import CustomerTypeFilter from './FilterCustomerType';
import CreditRatingFilter from './FilterCreditRating';
import DefaultRegistryFilter from './FilterDefaultRegistry';

function PortfolioFilter({ updateFilter, filterValues, isOpen }) {
  const { t } = useLocale();
  if (!isOpen) return null;

  return (
    <div className="box no-shadow">
      <div className="grid">
        <div className="col s1of3">
          <div className="text-semibold" style={{ marginBottom: '10px' }}>
            {t('portfolio_filter_title_customerType')}
          </div>
          <CustomerTypeFilter t={t} onChange={updateFilter} filterValues={filterValues} />
        </div>
        <div className="col s1of3 text-semibold">
          <div className="text-semibold" style={{ marginBottom: '10px' }}>
            {t('portfolio_filter_title_creditScore')}
          </div>
          <CreditRatingFilter t={t} onChange={updateFilter} filterValues={filterValues} />
        </div>
        <div className="col s1of3 text-semibold">
          <div className="text-semibold" style={{ marginBottom: '10px' }}>
            {t('portfolio_filter_title_defaultRegistry')}
          </div>
          <DefaultRegistryFilter t={t} onChange={updateFilter} filterValues={filterValues} />
        </div>
      </div>
      <div className="grid">
        <div className="col s5of12 gutter-top gutter-bottom">
          <div className="text-semibold divider" style={{ marginBottom: '10px' }}>
            {t('portfolio_filter_title_outstanding_invoices')}
          </div>
          <InputRange
            minValue={0}
            maxValue={filterValues.initCountMax}
            step={1}
            value={filterValues.countMax}
            formatLabel={(value) =>
              t('portfolio_portfolioFilter_range_invoices', formatNumber(value))
            }
            onChange={(val) => updateFilter('countMax', val)}
          />
        </div>
        <div className="col s1of12" />
        <div className="col s5of12 gutter-top gutter-bottom">
          <div className="text-semibold divider" style={{ marginBottom: '10px' }}>
            {t('portfolio_filter_title_paymentBehaviorOutstanding')}
          </div>
          <InputRange
            minValue={0}
            maxValue={filterValues.initOutstandingMax}
            step={1000}
            formatLabel={(value) => `${formatNumber(value)} kr.`}
            value={filterValues.outstandingDebt}
            onChange={(val) => updateFilter('outstandingDebt', val)}
          />
        </div>
      </div>
    </div>
  );
}

PortfolioFilter.propTypes = {
  updateFilter: PropTypes.func.isRequired,
  filterValues: PropTypes.object.isRequired,
};

export default PortfolioFilter;
